<template>
<el-dialog title="练习描述" :visible.sync="dialogFormVisible" center :before-close="handleClose">
    <div class="ibox edit-news_page" >
        <div class="ibox-content" v-loading="loading">
            <el-form ref="detailForm" :rules="rules" :model="form" label-width="0px" label-position="left">
                <el-row type="flex" justify="space-between">
                    <el-col :span="24">
                        <el-form-item prop="conbody">
                            <div class="news-body">
                                <vue-editor id="editor"
                                            useCustomImageHandler
                                            :editorToolbar="customToolbar"
                                            @imageAdded="handleImageAdded"
                                            v-model="form.conbody">
                                </vue-editor>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('detailForm')">保存</el-button>
                    <el-button type="primary" @click="dialogFormVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</el-dialog>
</template>

<script>
    import { VueEditor, Quill } from 'vue2-editor';
    import http from 'axios';
    import * as api from "@/api/market"
    
    export default {
        name: 'marketLeadsNewsColumnDetail',
        components: { VueEditor },
        props: {
            newsBody: { /// 练习描述内容
                type: Array,
                default: function(){
                    // return []
                }
            },
            changeBody: {
                type: Function,
                default: function() {}
            },
        },
        data() {
            return {
                type: 1,
                index:0,
                dialogFormVisible: false, // 控制显示隐藏
                loading: false,
                practices: {},
                form:{
                    conbody:'',
                },
                rules:{
                    conbody: [{ required: true, message: '请输入练习描述', trigger: 'blur' }],
                }
            }
        },
        computed: {
            customToolbar () { // 富文本操作
                return [
                    [{header: [1, 2, 3, 4, 5, 6, false]}],
                    [{ 'font': [] }],
                    [{size: ['small', false, 'large', 'huge']}],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ align: '' }, { align: 'center' }, { align: 'right' }],
                    ['bold', 'italic', 'underline', 'code-block',],
                    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
                    ['blockquote', 'code'],
                    [{direction: 'lt'}, {direction: 'rt'}],
                    ['formula', 'link'],
                    [{indent: '-1'}, {indent: '+1'}],
                    [{script: 'sub'}, {script: 'super'}],
                    ['strike', 'underline', 'video', 'image', 'clean'],
                    ['fullScreen', 'normalScreen'],
                    ['packUp', 'expand'],
                ]
            },
            // conbody() {
            //     return this.newsBody.content
            // }
        },
        watch: {
            index(newVal, oldVal){
                console.log(newVal)
                this.form.conbody = this.newsBody[newVal].content
            },
            newsBody(newVal, oldVal) {
                this.form.conbody = newVal[this.index].content
            }
        },
        activated() {
        },
        deactivated() {
            this.$refs['detailForm'] && this.$refs['detailForm'].resetFields();
        },
        mounted() {

            // this.practices = this.newsBody[this.index]
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        // 新建
                        this.newsBody[this.index].content = this.form.conbody
                        console.log(this.form.conbody,'conbdy')
                        let opts = {
                            content:this.form.conbody,
                            index: this.index,
                            type: this.type
                        }
                        this.changeBody({...opts})
                        this.dialogFormVisible = false
                    } else {
                        this.$message.warning('请输入练习!');
                        return false;
                    }
                })
            },
            async handleImageAdded (v, Editor, cursorLocation, resetUploader) {
                const _axios = http.create({
                    baseURL: process.env.BASE_API,
                    withCredentials: true,
                    timeout: 50000
                });
                let param = new FormData();
                param.append('file', v);
                param.append('chunk', '0');
                let config = {
                    headers:{'Content-Type':'multipart/form-data'}
                };
                _axios.post('/mate/uploadMaterial/', param, config).then((res) => {
                    Editor.insertEmbed(cursorLocation, 'image', res.data.data);
                    resetUploader();
                }).catch((err) => {
                    this.$message.error(err.message)
                })
            },
            resetForm() {
                // Object.keys(this.detailForm).forEach(k=> this.detailForm[k] = '')
            },
             handleClose() {
                this.dialogFormVisible = false
                this.$refs.detailForm.resetFields()
            }
        }
    }
</script>

<style lang="scss" scoped>
.edit-news_page {
        pre {
            width: 100%;
            padding: 20px 10px;
            min-height: 250px;
        }
        .ql-formats {
            display: flex;
            align-items: center;
            justify-content: space-around;
            button {
                padding: 0 !important;
            }
        }
        .ql-editor-perview {
            display: none;
        }
        .full-screen {
            padding: 10px;
            box-sizing: border-box;
            width: 100vw;
            height: 100vh;
            position: fixed;
            overflow: auto;
            top: 0;
            left: 0;
            background-color: #fff;
            z-index: 9999;
            .quillWrapper {
                height: 100%;
                .ql-container {
                    height: calc(100% - 70px);
                }
            }
        }
        .expand-screen {
            display: flex;
            .quillWrapper {
                width: 50%;
                height: 100%;
                .ql-container {
                    height: calc(100% - 100px);
                }
            }
            .ql-editor-perview {
                display: block;
                width: 50%;
                background: rgb(245,245,245);
                &.ql-editor {
                    height: auto;
                }
            }
        }
    }
</style>


